import { css } from '@emotion/css'
import { colors, fontWeight, spacing } from '@offerzen/pinata-shame'

const styles = {
  locationsList: css({
    listStyle: 'initial',
    marginTop: spacing.small,
    color: colors.jumbo,
    fontWeight: fontWeight.regular,

    b: {
      fontWeight: fontWeight.semiBold,
    },
  }),

  cityList: css({
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'inline',

    fontWeight: fontWeight.regular,

    '> li': {
      display: 'inline',

      ':not(:last-child)::after': {
        content: '", "',
      },
    },
  }),
}

export default styles
